export default __webpack_public_path__ + "static/media/contestImg2.c3d03aec.jpg";